// export default ({ store }, inject) => {
//   inject("notifier", {
//     showMessage({ content = "", color = "" }) {
//       store.commit("snackbar/showMessage", { content, color });
//     },
//   });
// };

export default {
  install(Vue, { store }) {
    if (this.installed) return;
    this.installed = true;

    const notify = {
      showMessage({ content = "", color = "" }) {
        store.commit("snackbar/showMessage", { content, color });
      },
    };

    Vue.prototype["$notifier"] = notify;
  },
};
